import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { action, observable, reaction } from 'mobx';
import { FormattedMessage } from 'ui/i18n';
import { render_date, render_amount } from 'utils';
import { authorize } from 'utils/auth';
import PaginationOptions from 'utils/domain/PaginationOptions';
import { INTERNAL_ERROR, BAD_REQUEST } from 'config/constants';

import {
	DataTable,
	ConcernMessage,
	OrderDetailsInfo,
	Loader,
	Unauthorized,
	ErrorLoadingContent,
} from 'ui/components';

import './OrderDetails.scss';

const columns = [
	{
		prop: 'line_number',
		title: <FormattedMessage id="ordersTable.lineNumberColumn" />,
		align: 'right',
	},
	{
		prop: 'product_number',
		title: <FormattedMessage id="ordersTable.productNumberColumn" />,
	},
	{
		prop: 'quantity',
		title: <FormattedMessage id="ordersTable.qtyColumn" />,
		align: 'right',
	},
	{
		prop: 'description',
		title: <FormattedMessage id="ordersTable.descriptionColumn" />,
	},
	{
		prop: 'unit_price',
		title: <FormattedMessage id="ordersTable.unitPriceColumn" />,
		align: 'right',
		render(row) {
			return render_amount(row[this.prop]);
		},
		noWrap: true,
	},
	{
		prop: 'planned_deliv_date',
		title: <FormattedMessage id="ordersTable.planDeliveryDateColumn" />,
		align: 'center',
		render(row) {
			return render_date(row[this.prop]);
		},
		noWrap: true,
	},
];

const SEARCH_PART_NUMBER = 'search-part-number';

@authorize({
	rights: ['GetOrderDetails', 'GetOrderHistory'],
	Instead: Unauthorized,
})
@inject('OrdersState', 'AppState')
@observer
export default class OrderDetailsPage extends Component {
	static propTypes = {
		OrdersState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		match: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
	};

	componentWillMount() {
		window.scrollTo(0, 0);
		this.OrdersState.fetchOrderDetails(this.orderNumber);

		reaction(
			() => this.pagination,
			() =>
				this.OrdersState.fetchOrderProducts(this.orderNumber, this.pagination),
			true
		);
	}

	OrdersState = this.props.OrdersState;
	orderNumber = this.props.match.params.OrderNumber;
	history = this.props.history;
	locations = this.props.AppState.locations;
	MIN_HISTORY_LENGTH = 1;

	@observable pagination = new PaginationOptions();

	goBack() {
		if (this.locations.length > this.MIN_HISTORY_LENGTH) {
			this.history.goBack();
		} else {
			window.location = '/';
		}
	}

	getGoBackText() {
		if (this.locations.length > this.MIN_HISTORY_LENGTH) {
			return this.locations[1].includes(SEARCH_PART_NUMBER)
				? 'orderDetails.backToSearchPart'
				: 'orderDetails.backToOrderHistory';
		}
		return 'orderDetails.backToHome';
	}

	@action
	handlePaginationChange(pagination) {
		this.pagination = pagination;
	}

	render() {
		const { fetchOrderDetails, fetchOrderProducts } = this.props.OrdersState;
		const userCountry = this.props.AppState.user.country.short_name;

		return (
			<div className="OrderDetails">
				<div
					id="OrderDetails-header-orderNumber"
					className="OrderDetails-header"
				>
					<FormattedMessage id="orderDetails.headerText" /> {this.orderNumber}
				</div>

				{fetchOrderDetails.handle({
					loading: () => <Loader />,
					rejected: error =>
						<div>
							{error.status === INTERNAL_ERROR || error.status === BAD_REQUEST
								? <ErrorLoadingContent />
								: <div className="Error__not-available">
										<h3>
											<FormattedMessage
												id="orderdetails.NotAvailable"
												values={{ orderNumber: this.orderNumber }}
											/>
										</h3>
									</div>}
						</div>,
					resolved: order_details =>
						<div className="OrderDetails-content">
							<div
								id="OrderDetails-button-back"
								className="OrderDetails--back-to"
								onClick={this.goBack.bind(this)}
							>
								<FormattedMessage id={this.getGoBackText()} />
							</div>

							<OrderDetailsInfo details={order_details} />

							<div className="OrderDetails__products">
								{fetchOrderProducts.handle({
									loading: () => <Loader />,
									resolved: products =>
										<DataTable
											id="OrderDetails__products_table"
											columns={columns}
											rows={products}
											count={order_details.count}
											pagination={this.pagination}
											onPaginationChange={this.handlePaginationChange.bind(
												this
											)}
										/>,
								})}
							</div>
						</div>,
				})}

				<ConcernMessage userCountry={userCountry} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/OrderDetails/index.js